import React, { Component, Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import './Program.css';
import { ProgramHeading } from './shared/ProgramHeading';
import { ProgramItem } from './shared/ProgramItem';

import { getClient } from './shared/auth.js';

const locale = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};

export class Program extends Component {

  constructor(props) {
    super(props);
    let today = new Date();
    let date = this.getSunday(today);
    let year, month, day;
    if(this.props.match){
      let params = this.props.match.params;
      year = +params.year || date.getFullYear();
      month = parseInt(params.month) || date.getMonth() + 1;
      day = parseInt(params.day) || date.getDate();
    } else {
      year = date.getFullYear();
      month = date.getMonth() + 1;
      day = date.getDate();
    }
    let sunday = this.getSunday(new Date(year, month-1, day));
    this.year = sunday.getFullYear();
    this.month = sunday.getMonth() + 1;
    this.day = sunday.getDate();
    this.date = sunday;

    this.state = {
      isLoaded: false,
      manual: false,
      program: {},
      isFirstSunday: this.isFirstSunday(sunday),
      hasRestHymn: false,
      hasMusicalNumber: false,
      table: {}
    };
  }

  isFirstSunday(sunday) {
    while (sunday.getDay() !== 0)
    {
      sunday.setDate(sunday.getDate() + 1);
    }

    return sunday.getDate() <= 7;
  }

  async componentDidMount() {
    // Manual Update
    let manual = await fetch('/data/program.json')
      .then(res => {return res.ok ? res.json() : {Date: ""}})
      .catch(err=>null)
      .then(data => {
        if (data == null){
          return false;
        }
        let manual = true;
        (data.Date == this.date.toLocaleDateString('en-US', locale)) ? 
        this.setState({
          program: data,
          manual: true,
          isLoaded: true
        }) :  manual = false;
        return manual;
      });
    if (manual == true) return;
    // Automatic Update
    const keys = require('../gsa-creds.json');
    const sheet = require('../sheet.json');
    let {year, month, day} = this;
    console.log(year, month, day);
    const query = `select * where C = date '${year}-${month}-${day}'`;
    const sheetId = sheet.sheets.program;
    const url = `https://docs.google.com/spreadsheets/d/${sheet.id}/gviz/tq?tqx=out:json&tq=${encodeURIComponent(query)}#gid=${sheetId}`;
    getClient(keys, ["https://www.googleapis.com/auth/drive.readonly"]).then(client => {
      client.request({url})
        .then(res => res.data)
        .then(data => data.split(/setResponse\(|\);/)[1])
        .then(data => JSON.parse(data))
        .then(
          data => {
            const table = data.table;
            const row0 = table.rows[0].c;
            const row1 = table.rows[1].c;
            const row2 = table.rows[2].c;
            const row3 = table.rows[3].c;
            const others = table.rows.slice(4).map(r => r?.c).filter(r => r);
            const program = {
              type: row3[0]?.v,
              Conducting: row1[0]?.v == "Miller" ? "Bishop Brett Miller" : ( row1[0]?.v == "Giles" ? "Matt Giles" : ( row1[0]?.v == "Ludden" ? "David Ludden" : "")),
              Presiding: row2[0]?.v ?? "Bishop Brett Miller",
              Date: `Sunday, ${row0[0]?.v}`,
              Chorister: row0[12]?.v?.split(': ')[1] ?? "To Be Announced",
              Organist: row2[12]?.v?.split(': ')[1] ?? "To Be Announced",
              OpeningHymn: row0[10]?.v ?? "To Be Announced",
              Invocation: row1[11]?.v ?? "To Be Announced",
              SacramentHymn: row1[10]?.v ?? "To Be Announced",
              Speakers: [row0[6]?.v ?? "", row1[6]?.v ?? "", row2[6]?.v ?? "", row3[6]?.v ?? "", others.map(r => r[6]?.v ?? "")].filter(e => e != ""),
              RestHymn: row2[10]?.v?.startsWith('#') ? row2[10].v : "",
              MusicalNumber: row2[10]?.v ? [row2[10].v] : [],
              ClosingHymn: row3[10]?.v ?? "To Be Announced",
              Benediction: row3[11]?.v ?? "To Be Announced"
            }
            console.log(program);
            this.setState({
              isLoaded: true,
              program,
              hasRestHymn: !!program['RestHymn'],
              hasMusicalNumber: !!program['MusicalNumber'] && (program['MusicalNumber'].length != 0),
              table
            });
          }
        )
      });
  }

  daysTilSunday(currentDay) {
    let days = 0;
    if (days + currentDay === 0){
      return days;
    }
    while (days + currentDay <= 6)
    {
      days++;
    }
    return days;
  }

  addDays(date, days) {
  // Add a number of days to a date
  let result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

  getSunday(today)
  {
    var daysTilSunday = this.daysTilSunday(today.getDay());
    var sunday = this.addDays(today, daysTilSunday);
    return sunday;
  }

  getSpeakers()
  {
    const {program, hasRestHymn, hasMusicalNumber} = this.state;
    const isFastSunday = (program.type == "Fast Sunday");
    if(isFastSunday){
      return <ProgramHeading text="Sharing of Testimonies" />;
    } else {
      let speakers = program.Speakers.map(
        (speaker, ind) => (<ProgramItem leftText="Speaker" rightText={speaker} key={ind} />)
      );
      if(hasRestHymn){
        speakers.splice(speakers.length > 2 ? 2 : -1, 0, (<Fragment key="rest"><hr /> <ProgramItem leftText="Rest Hymn" rightText={program.RestHymn} /> <hr /></Fragment>));
      } else if(hasMusicalNumber){
        let musicalNumber = program.MusicalNumber;
        speakers.splice(speakers.length > 2 ? 2 : -1, 0, <Fragment key="musical">
          <hr/>
          <ProgramItem leftText="Musical Number" rightText={musicalNumber.length > 1 ? `${musicalNumber.slice(0, -1).join(', ')} and ${musicalNumber.slice(-1).join('')}` : musicalNumber} />
          <hr/>
        </Fragment>)
      }
      return speakers;
    }
  }

  render() {
    const { date } = this;
    const {isLoaded, program, manual} = this.state;
    if(!isLoaded){
      return <div>Loading...</div>;
    } else if(manual){
      const programItems = program.items.map((item, index) => {
  return (
    <Fragment key={index}>
      {
        item.type == "heading"
        ? <ProgramHeading text={item.text} />
        : (item.type == "hr" ? <hr />
        :<ProgramItem leftText={item.left} rightText={item.right}/>)
      }
    </Fragment>
  );
});
      return (
        <div className="container programContainer">
          <br />
          <ProgramHeading text={date.toLocaleDateString('en-US', locale)} />
          {programItems}
        </div>
      )
    } else {
      switch(program.type){
        case "Normal Sacrament":
          break;
        case "General Conference":
          return <div>No Sacrament Meeting Today due to General Conference.</div>;
        case "Easter":
          return <div>Easter Program Unavailable</div>
        default:
          break;
      }
      return (
        <div className="container programContainer">
          <br />
          <ProgramHeading text={date.toLocaleDateString('en-US', locale)} />
          <ProgramItem leftText="Presiding" rightText={program.Presiding} />
          <ProgramItem leftText="Conducting" rightText={program.Conducting} />
          <ProgramItem leftText="Chorister" rightText={program.Chorister} />
          <ProgramItem leftText="Organist" rightText={program.Organist} />
          <ProgramHeading text="Welcome / Announcements" />
          <ProgramItem leftText="Opening Hymn" rightText={program.OpeningHymn} />
          <ProgramItem leftText="Invocation" rightText={program.Invocation} />
          <ProgramHeading text="Ward Business" />
          <ProgramItem leftText="Sacrament Hymn" rightText={program.SacramentHymn} />
          <ProgramHeading text="Administration of the Sacrament" />
          <hr></hr>
          {
            this.getSpeakers()
          }
          <hr></hr>
          <ProgramItem leftText="Closing Hymn" rightText={program.ClosingHymn} />
          <ProgramItem leftText="Benediction" rightText={program.Benediction} />
          <br />
          <br />
          <br />
        </div>
      );
    }
  }
}



  

export default (Program);